import { render, staticRenderFns } from "./ErrorTemplate.vue?vue&type=template&id=3aaddd2a&scoped=true&"
var script = {}
import style0 from "./ErrorTemplate.vue?vue&type=style&index=0&id=3aaddd2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aaddd2a",
  null
  
)

export default component.exports